import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

export const apiFetchMrdMonitoringReportsXmlDelayed = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdMonitoringReportsAllMRDs',
    stub: process.env.useStubbedEndpoints,
    queryStringParams: {
      filter: 'XmlDelayed',
    },
  });
  return axios.get(serviceURL, payload);
};
